<body class="">
  <main>
    <div class="partical_all">
      <div id="stars"></div>
      <div id="stars2"></div>
      <div id="stars3"></div>
      <div id="particle-container">
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row align-items-center top">
        <div class="col-lg-7">
          <div class="row">
            <div class="col-lg-8 mid">
              <div class="left_first_box">
                <h1 class="c-article__title">
                  ONLINE MARKETING BUSINESS SOLUTIONS
                </h1>
              </div>
              <div class="content">
                <p>
                  Don't let your history define your destiny. What lies ahead is
                  what's more important. At ONPASSIVE, we are making history by
                  helping millions make their own destiny. With a full-fledged
                  AI-driven network marketing business, you can make your mark
                  in the marketing world.
                </p>
              </div>
              <div class="video_box acc_panel">
                <video
                  id="my-video"
                  class="video-js video-size w-100 h-auto"
                  controls
                  preload="auto"
                  poster="{{ myLinksS3URL }}images/Image0231.png"
                  data-setup="{}"
                  autoplay="true"
                  muted
                >
                  <source
                    src="{{
                      myLinksS3URL
                    }}videos/Onpassive_launching_page_video.mp4"
                    type="video/mp4"
                  />
                </video>
              </div>
            </div>
            <div class="col-lg-4 mob_top">
              <div class="logo">
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(23thnov)/images/logo_one.png"
                  alt="logo"
                />
              </div>
              <div class="text_box">
                <h1 class="launch">L A U N C H I N G S O O N</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="face-wrap">
        <img
          src="{{ onPassiveBaseUrl }}onpassive(23thnov)/images/face-1.png"
          alt="face-1"
          class="img-fluid face-1"
        />
        <img
          src="{{ onPassiveBaseUrl }}onpassive(23thnov)/images/face-2.png"
          alt="face-2"
          class="img-fluid face-2"
        />
        <img
          src="{{ onPassiveBaseUrl }}onpassive(23thnov)/images/face-3.png"
          alt="face-3"
          class="img-fluid face-3"
        />
        <img
          src="{{
            onPassiveBaseUrl
          }}onpassive(23thnov)/images/face-inner-shadow.png"
          alt="shadow"
          class="img-fluid face-4"
        />
        <img
          src="{{
            onPassiveBaseUrl
          }}onpassive(23thnov)/images/face-outer-shadow.png"
          alt="shadow"
          class="img-fluid face-5"
        />
      </div>
    </div>
    <div class="founder-btn">
      <a
        href="/registration/user?reg={{ userId }}"
        name="regform"
        target="_blank"
        rel="noopener"
        class="btn btn-primary btn-founder"
      >
        <span>BECOME A FOUNDER NOW</span>
      </a>
    </div>
  </main>
</body>
